// ¿Se usa el onboarding de marca? (ADR-2026-09-28-onboarding-v2-etapa-1)
//
// Desde ADR-2026-10-31-onboarding-corto-para-la-prueba ya no decide qué se monta en
// `/configuracion-cuenta` (ahí va siempre el cuestionario corto): decide si existen
// `/configurar-marca` (el que debe quien empieza a pagar), "Añadir nueva marca" y
// "Describí tu marca".
//   - `VITE_ONBOARDING_MARCA=true` lo prende para todo el deploy;
//   - `localStorage['atlas:onboarding_marca_on'] = '1'` lo prende en un navegador, para
//     probarlo en producción sin cambiar el de nadie más.
// Se lee una vez al cargar: las rutas se arman con esto.

export function onboardingDeMarcaActivo(): boolean {
  if (import.meta.env.VITE_ONBOARDING_MARCA === 'true') return true;
  try {
    return localStorage.getItem('atlas:onboarding_marca_on') === '1';
  } catch {
    return false;
  }
}
